export const VALID_FIELD_STATE = {
  errorCode: '',
  isValid: true,
};

export const AUTO_COMPLETE_TYPE = {
  ANS: 'ANS',
  BROWSER: 'BROWSER',
  GOOGLE: 'GOOGLE',
  MANUAL: 'MANUAL',
  MERCHANT_PREFILLED: 'MERCHANT_PREFILLED',
};

export const CARD_FIELDS_TO_DISPLAY = {
  cvv: true,
  dob: false,
  expiry: true,
};
